import axios from 'axios'

export default () => {
   // return axios.create({baseURL: "http://localhost:8080"})
   return axios.create({baseURL: "https://runaway-rascals-go-gin-api.herokuapp.com"})
}